import { gql } from 'graphql-request';

export default gql`
  fragment ActivityCard on ActivityPage {
    url
    activity {
      slug
      title
      areaChoiceDisplay
      theme {
        icon
        name
      }
      background: heroFallbackImage {
        ... on ImageObjectType {
          image: rendition(fill: "500x600-c100") {
            url
          }
        }
      }
    }
  }
  fragment CustomActivityCard on CustomActivityPage {
    slug
    title
    areaChoiceDisplay
    url
    theme {
      icon
      name
    }
    background: heroFallbackImage {
      ... on ImageObjectType {
        image: rendition(fill: "500x600-c100") {
          url
        }
      }
    }
  }
`;
